import { VideoPlayerAspectRatio } from "@switcherstudio/switcher-api-client";

export const displayAspectRatio = (
    ratio: VideoPlayerAspectRatio
): "16:9" | "9:16" => {
    switch (ratio) {
        case VideoPlayerAspectRatio.SixteenByNine:
            return "16:9";
        case VideoPlayerAspectRatio.NineBySixteen:
            return "9:16";
    }
};

export const displayFileSize = (sizeInBytes: number): string => {
    if (sizeInBytes < 1024) {
        return `${sizeInBytes} B`;
    } else if (sizeInBytes < 1024 * 1024) {
        return `${(sizeInBytes / 1024).toFixed(2)} KB`;
    } else if (sizeInBytes < 1024 * 1024 * 1024) {
        return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
    } else {
        return `${(sizeInBytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
    }
};
